module.exports = __webpack_public_path__ + "media/img/pages/profile/axpo ger 9-b7477f8cd5c43529634b5afbea566269.jpg";